import { render } from "./EventAttendanceList.vue?vue&type=template&id=60d9403c"
import script from "./EventAttendanceList.vue?vue&type=script&lang=js"
export * from "./EventAttendanceList.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__